import { render, staticRenderFns } from "./SIC.vue?vue&type=template&id=873c1e94&"
import script from "./SIC.vue?vue&type=script&lang=js&"
export * from "./SIC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports